// extracted by mini-css-extract-plugin
export default {"cardImg":"BoardScreen_cardImg__DYjvd","cardStyles":"BoardScreen_cardStyles__1bzJQ","cardText":"BoardScreen_cardText__vXnZR","cardTitle":"BoardScreen_cardTitle__e-i0v"};